import React, { useState, useEffect, useCallback, useRef } from "react";
import "./ChallengePage.css";

// 150 Question Bank
const QUESTION_BANK = [
  { question: "A train travels 60 km in 1 hour. How far will it travel in 3 hours?", options: ["120 km", "150 km", "180 km", "200 km"], answer: "180 km" },
  { question: "What is the capital of France?", options: ["Berlin", "Madrid", "Paris", "Rome"], answer: "Paris" },
  { question: "Which chemical element has the symbol 'O'?", options: ["Gold", "Oxygen", "Osmium", "Zinc"], answer: "Oxygen" },
  { question: "What is 15 multiplied by 8?", options: ["110", "120", "130", "140"], answer: "120" },
  { question: "Which planet is known as the Red Planet?", options: ["Venus", "Jupiter", "Mars", "Saturn"], answer: "Mars" },
  { question: "What is the square root of 144?", options: ["10", "11", "12", "14"], answer: "12" },
  { question: "Who wrote 'Romeo and Juliet'?", options: ["Charles Dickens", "William Shakespeare", "Mark Twain", "Jane Austen"], answer: "William Shakespeare" },
  { question: "What is the primary gas in Earth's atmosphere?", options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Hydrogen"], answer: "Nitrogen" },
  { question: "How many sides does a hexagon have?", options: ["5", "6", "7", "8"], answer: "6" },
  { question: "What is 2^5 (2 to the power of 5)?", options: ["16", "25", "32", "64"], answer: "32" },
  { question: "Which continent is the South Pole located in?", options: ["Asia", "Antarctica", "Australia", "Europe"], answer: "Antarctica" },
  { question: "What is the freezing point of water in Celsius?", options: ["-10°C", "0°C", "32°C", "100°C"], answer: "0°C" },
  { question: "Solve for x: 3x + 9 = 24", options: ["3", "4", "5", "6"], answer: "5" },
  { question: "Which organ pumps blood throughout the human body?", options: ["Brain", "Lungs", "Heart", "Liver"], answer: "Heart" },
  { question: "What is the boiling point of water in Celsius?", options: ["90°C", "100°C", "110°C", "120°C"], answer: "100°C" },
  { question: "How many minutes are in a full day?", options: ["1200", "1440", "1600", "1800"], answer: "1440" },
  { question: "Which gas do plants absorb during photosynthesis?", options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Helium"], answer: "Carbon Dioxide" },
  { question: "What is the largest mammal in the world?", options: ["Elephant", "Blue Whale", "Giraffe", "Great White Shark"], answer: "Blue Whale" },
  { question: "What is 99 divided by 9?", options: ["9", "10", "11", "12"], answer: "11" },
  { question: "Which device converts electrical energy into mechanical energy?", options: ["Generator", "Motor", "Transformer", "Battery"], answer: "Motor" },
  { question: "What is the smallest prime number?", options: ["0", "1", "2", "3"], answer: "2" },
  { question: "What is the speed of light approximately?", options: ["300,000 km/s", "150,000 km/s", "1,000,000 km/s", "500,000 km/s"], answer: "300,000 km/s" },
  { question: "How many bones are in the adult human body?", options: ["196", "206", "216", "226"], answer: "206" },
  { question: "What is the perimeter of a square with a side length of 7 cm?", options: ["14 cm", "21 cm", "28 cm", "49 cm"], answer: "28 cm" },
  { question: "Which element is essential for bone health?", options: ["Iron", "Calcium", "Sodium", "Potassium"], answer: "Calcium" },
  { question: "What is the SI unit of electric current?", options: ["Volt", "Watt", "Ampere", "Ohm"], answer: "Ampere" },
  { question: "How many degrees are in a right angle?", options: ["45°", "90°", "180°", "360°"], answer: "90°" },
  { question: "Which galaxy contains our Solar System?", options: ["Andromeda", "Milky Way", "Triangulum", "Centaurus A"], answer: "Milky Way" },
  { question: "What is 75% of 200?", options: ["120", "140", "150", "160"], answer: "150" },
  { question: "Who developed the theory of relativity?", options: ["Isaac Newton", "Albert Einstein", "Nikola Tesla", "Galileo Galilei"], answer: "Albert Einstein" },
  { question: "What is the chemical formula for water?", options: ["CO2", "H2O", "NaCl", "O2"], answer: "H2O" },
  { question: "What is the sum of angles in a triangle?", options: ["90°", "180°", "270°", "360°"], answer: "180°" },
  { question: "Which planet is closest to the Sun?", options: ["Venus", "Earth", "Mercury", "Mars"], answer: "Mercury" },
  { question: "What is 12 x 12?", options: ["124", "134", "144", "154"], answer: "144" },
  { question: "What is the main component of natural gas?", options: ["Ethane", "Methane", "Propane", "Butane"], answer: "Methane" },
  { question: "Which organ produces insulin in the human body?", options: ["Liver", "Pancreas", "Kidney", "Stomach"], answer: "Pancreas" },
  { question: "If a car travels at 80 km/h, how far will it travel in 2.5 hours?", options: ["160 km", "180 km", "200 km", "220 km"], answer: "200 km" },
  { question: "What is the value of Pi (approximate to 2 decimal places)?", options: ["3.12", "3.14", "3.16", "3.18"], answer: "3.14" },
  { question: "Which instrument measures atmospheric pressure?", options: ["Thermometer", "Barometer", "Hydrometer", "Anemometer"], answer: "Barometer" },
  { question: "What is the hardest natural substance on Earth?", options: ["Gold", "Iron", "Diamond", "Quartz"], answer: "Diamond" },
  { question: "How many legs does a spider typically have?", options: ["6", "8", "10", "12"], answer: "8" },
  { question: "What is the value of 5!", options: ["20", "60", "120", "240"], answer: "120" },
  { question: "Which part of the cell contains genetic material?", options: ["Cytoplasm", "Nucleus", "Ribosome", "Cell Wall"], answer: "Nucleus" },
  { question: "What is the SI unit of force?", options: ["Joule", "Watt", "Pascal", "Newton"], answer: "Newton" },
  { question: "How many sides does an octagon have?", options: ["6", "7", "8", "9"], answer: "8" },
  { question: "What is the process by which liquid turns to gas?", options: ["Condensation", "Evaporation", "Sublimation", "Freezing"], answer: "Evaporation" },
  { question: "Solve: 50 - (6 x 7)", options: ["8", "12", "14", "18"], answer: "8" },
  { question: "Which pigment gives plants their green color?", options: ["Carotene", "Chlorophyll", "Hemoglobin", "Melanin"], answer: "Chlorophyll" },
  { question: "What is the atomic number of Hydrogen?", options: ["1", "2", "6", "8"], answer: "1" },
  { question: "How many milliseconds are in one second?", options: ["10", "100", "1000", "10000"], answer: "1000" },
  { question: "What is the hypotenuse of a right triangle with sides 3 and 4?", options: ["5", "6", "7", "8"], answer: "5" },
  { question: "Which planet has the most visible ring system?", options: ["Jupiter", "Saturn", "Uranus", "Neptune"], answer: "Saturn" },
  { question: "What is the functional unit of the human kidney?", options: ["Neuron", "Nephron", "Alveoli", "Cell"], answer: "Nephron" },
  { question: "Solve for y: 2y - 5 = 11", options: ["6", "7", "8", "9"], answer: "8" },
  { question: "Which blood type is considered the universal donor?", options: ["A+", "B+", "AB+", "O-"], answer: "O-" },
  { question: "What is 10 cubed (10^3)?", options: ["100", "500", "1000", "10000"], answer: "1000" },
  { question: "Which subatomic particle carries a negative charge?", options: ["Proton", "Neutron", "Electron", "Photon"], answer: "Electron" },
  { question: "What is the chemical symbol for Gold?", options: ["Ag", "Au", "Fe", "Pb"], answer: "Au" },
  { question: "How many dynamic colors are in a standard rainbow?", options: ["5", "6", "7", "8"], answer: "7" },
  { question: "Which layer of Earth is composed of liquid iron and nickel?", options: ["Crust", "Mantle", "Outer Core", "Inner Core"], answer: "Outer Core" },
  { question: "What is 1/4 expressed as a percentage?", options: ["20%", "25%", "30%", "40%"], answer: "25%" },
  { question: "What type of energy is stored in a compressed spring?", options: ["Kinetic", "Potential", "Thermal", "Chemical"], answer: "Potential" },
  { question: "Which organelle is known as the powerhouse of the cell?", options: ["Nucleus", "Mitochondria", "Golgi Body", "Vacuole"], answer: "Mitochondria" },
  { question: "What is the median of the dataset [3, 7, 9, 12, 15]?", options: ["7", "9", "10", "12"], answer: "9" },
  { question: "What is the speed formula?", options: ["Speed = Distance x Time", "Speed = Distance / Time", "Speed = Time / Distance", "Speed = Distance + Time"], answer: "Speed = Distance / Time" },
  { question: "Which vitamin is primarily synthesized from sunlight exposure?", options: ["Vitamin A", "Vitamin B12", "Vitamin C", "Vitamin D"], answer: "Vitamin D" },
  { question: "What is the sum of 1/2 and 1/4?", options: ["2/4", "3/4", "1/6", "4/4"], answer: "3/4" },
  { question: "What device converts light energy into electrical energy?", options: ["Solar Cell", "LED", "Resistor", "Capacitor"], answer: "Solar Cell" },
  { question: "Which acid is present in human stomach juice?", options: ["Sulfuric Acid", "Nitric Acid", "Hydrochloric Acid", "Acetic Acid"], answer: "Hydrochloric Acid" },
  { question: "What is the cube root of 64?", options: ["2", "4", "6", "8"], answer: "4" },
  { question: "Which fundamental force keeps planets in orbit around the Sun?", options: ["Electromagnetic Force", "Gravitational Force", "Strong Nuclear Force", "Weak Nuclear Force"], answer: "Gravitational Force" },
  { question: "How many items are in a baker's dozen?", options: ["12", "13", "14", "15"], answer: "13" },
  { question: "What is the derivative of a constant value?", options: ["0", "1", "Constant", "Undefined"], answer: "0" },
  { question: "Which organ in the human body cleanses blood and removes toxins?", options: ["Heart", "Liver", "Stomach", "Spleen"], answer: "Liver" },
  { question: "What is 40% of 50?", options: ["15", "20", "25", "30"], answer: "20" },
  { question: "Which part of the brain controls balance and coordination?", options: ["Cerebrum", "Cerebellum", "Brainstem", "Thalamus"], answer: "Cerebellum" },
  { question: "What is the chemical symbol for Sodium?", options: ["So", "Na", "Sd", "K"], answer: "Na" },
  { question: "Solve for x: x^2 = 81", options: ["7", "8", "9", "10"], answer: "9" },
  { question: "What instrument is used to detect earthquakes?", options: ["Seismograph", "Barometer", "Radar", "Sonar"], answer: "Seismograph" },
  { question: "What is the chemical formula for Carbon Dioxide?", options: ["CO", "CO2", "C2O", "HCO3"], answer: "CO2" },
  { question: "What is the average of 10, 20, and 30?", options: ["15", "20", "25", "30"], answer: "20" },
  { question: "Which blood cells help fight infection?", options: ["Red Blood Cells", "White Blood Cells", "Platelets", "Plasma"], answer: "White Blood Cells" },
  { question: "What gas do humans exhale in the highest concentration?", options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Argon"], answer: "Nitrogen" },
  { question: "What is the area of a circle formula?", options: ["πr", "2πr", "πr²", "πd"], answer: "πr²" },
  { question: "Which lens type converges light rays to a point?", options: ["Concave Lens", "Convex Lens", "Flat Lens", "Cylindrical Lens"], answer: "Convex Lens" },
  { question: "What is the square of 15?", options: ["205", "215", "225", "235"], answer: "225" },
  { question: "What type of wave is sound?", options: ["Transverse Wave", "Longitudinal Wave", "Electromagnetic Wave", "Surface Wave"], answer: "Longitudinal Wave" },
  { question: "Which part of the flower receives pollen during pollination?", options: ["Petal", "Stamen", "Stigma", "Sepal"], answer: "Stigma" },
  { question: "What is 100 divided by 0.5?", options: ["50", "100", "200", "400"], answer: "200" },
  { question: "What unit measures electrical resistance?", options: ["Volt", "Watt", "Ohm", "Farad"], answer: "Ohm" },
  { question: "Which hormone regulates blood sugar levels?", options: ["Adrenaline", "Insulin", "Thyroxine", "Estrogen"], answer: "Insulin" },
  { question: "How many faces does a cube have?", options: ["4", "6", "8", "12"], answer: "6" },
  { question: "What is the lightest element in the periodic table?", options: ["Helium", "Hydrogen", "Lithium", "Carbon"], answer: "Hydrogen" },
  { question: "What is 13 multiplied by 7?", options: ["81", "91", "101", "111"], answer: "91" },
  { question: "Which gas is commonly known as laughing gas?", options: ["Nitrous Oxide", "Carbon Monoxide", "Methane", "Sulfur Dioxide"], answer: "Nitrous Oxide" },
  { question: "What is the slope-intercept form equation of a line?", options: ["y = mx + b", "Ax + By = C", "y - y1 = m(x - x1)", "x/a + y/b = 1"], answer: "y = mx + b" },
  { question: "Which structure connects muscle to bone?", options: ["Ligament", "Tendon", "Cartilage", "Joint"], answer: "Tendon" },
  { question: "What is 5 cubed (5^3)?", options: ["25", "75", "125", "625"], answer: "125" },
  { question: "What is the pH level of pure water?", options: ["0", "5", "7", "14"], answer: "7" },
  { question: "Which force opposes relative motion between two surfaces?", options: ["Gravity", "Friction", "Tension", "Thrust"], answer: "Friction" },
  // Additional 50 Questions (101 to 150)
  { question: "What is the main gas found in the Sun?", options: ["Oxygen", "Hydrogen", "Helium", "Nitrogen"], answer: "Hydrogen" },
  { question: "Which unit is used to measure frequency?", options: ["Hertz", "Watt", "Joule", "Pascal"], answer: "Hertz" },
  { question: "What is 20% of 150?", options: ["20", "25", "30", "35"], answer: "30" },
  { question: "Which human organ consumes the most energy?", options: ["Heart", "Liver", "Brain", "Kidney"], answer: "Brain" },
  { question: "What is the capital of Japan?", options: ["Kyoto", "Osaka", "Tokyo", "Hiroshima"], answer: "Tokyo" },
  { question: "What is the sum of angles in a quadrilateral?", options: ["180°", "270°", "360°", "540°"], answer: "360°" },
  { question: "Which planet is known for its Great Red Spot?", options: ["Jupiter", "Mars", "Saturn", "Neptune"], answer: "Jupiter" },
  { question: "What is the value of 3^4 (3 to the power of 4)?", options: ["27", "64", "81", "243"], answer: "81" },
  { question: "Which vitamin is water-soluble?", options: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin K"], answer: "Vitamin C" },
  { question: "What is the SI unit of temperature?", options: ["Celsius", "Fahrenheit", "Kelvin", "Joule"], answer: "Kelvin" },
  { question: "What gas is used to inflate party balloons?", options: ["Oxygen", "Helium", "Nitrogen", "Argon"], answer: "Helium" },
  { question: "How many colors make up sunlight when passed through a prism?", options: ["5", "6", "7", "8"], answer: "7" },
  { question: "What is 16 x 5?", options: ["70", "75", "80", "85"], answer: "80" },
  { question: "Which is the smallest organ in the human body?", options: ["Pineal Gland", "Pituitary Gland", "Stapes", "Skin"], answer: "Pineal Gland" },
  { question: "What is the chemical symbol for Iron?", options: ["Ir", "Fe", "In", "Pb"], answer: "Fe" },
  { question: "Which planet is the hottest in our solar system?", options: ["Mercury", "Venus", "Mars", "Jupiter"], answer: "Venus" },
  { question: "Solve for x: 5x - 10 = 35", options: ["7", "8", "9", "10"], answer: "9" },
  { question: "Which ocean is the largest on Earth?", options: ["Atlantic Ocean", "Indian Ocean", "Arctic Ocean", "Pacific Ocean"], answer: "Pacific Ocean" },
  { question: "What is 1000 divided by 8?", options: ["110", "120", "125", "130"], answer: "125" },
  { question: "Which gas is produced during plant respiration?", options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Methane"], answer: "Carbon Dioxide" },
  { question: "What is the normal body temperature of humans in Celsius?", options: ["35°C", "37°C", "39°C", "40°C"], answer: "37°C" },
  { question: "How many millimeters are in 1 meter?", options: ["100", "1000", "10000", "100000"], answer: "1000" },
  { question: "Which blood vessels carry oxygenated blood away from the heart?", options: ["Veins", "Arteries", "Capillaries", "Venules"], answer: "Arteries" },
  { question: "What is the chemical symbol for Silver?", options: ["Si", "Ag", "Au", "Sv"], answer: "Ag" },
  { question: "What is 14 x 6?", options: ["74", "84", "94", "104"], answer: "84" },
  { question: "Which instrument measures wind speed?", options: ["Barometer", "Anemometer", "Hygrometer", "Thermometer"], answer: "Anemometer" },
  { question: "What type of reflection occurs on a smooth surface?", options: ["Diffuse", "Specular", "Refracted", "Absorbed"], answer: "Specular" },
  { question: "What is the value of 0!", options: ["0", "1", "Undefined", "Infinity"], answer: "1" },
  { question: "Which organ stores bile in the human body?", options: ["Liver", "Gallbladder", "Pancreas", "Stomach"], answer: "Gallbladder" },
  { question: "What is the atomic number of Carbon?", options: ["4", "6", "8", "12"], answer: "6" },
  { question: "How many prime numbers are between 1 and 10?", options: ["3", "4", "5", "6"], answer: "4" },
  { question: "Which law states that action and reaction are equal and opposite?", options: ["Newton's First Law", "Newton's Second Law", "Newton's Third Law", "Law of Gravitation"], answer: "Newton's Third Law" },
  { question: "What is the largest organ of the human body?", options: ["Liver", "Brain", "Skin", "Lungs"], answer: "Skin" },
  { question: "What is 8 cubed (8^3)?", options: ["256", "512", "1024", "2048"], answer: "512" },
  { question: "Which gas is essential for human respiration?", options: ["Carbon Dioxide", "Oxygen", "Nitrogen", "Hydrogen"], answer: "Oxygen" },
  { question: "What is the chemical formula for Table Salt?", options: ["NaCl", "KCl", "CaCl2", "HCl"], answer: "NaCl" },
  { question: "Which continent is known as the Dark Continent?", options: ["Asia", "Africa", "South America", "Australia"], answer: "Africa" },
  { question: "What is the square root of 225?", options: ["13", "14", "15", "16"], answer: "15" },
  { question: "Which metal is liquid at room temperature?", options: ["Gold", "Mercury", "Copper", "Lead"], answer: "Mercury" },
  { question: "How many planck units define spatial dimensions in basic geometry?", options: ["1", "2", "3", "4"], answer: "3" },
  { question: "What is 18 x 4?", options: ["68", "72", "76", "80"], answer: "72" },
  { question: "Which part of the ear is responsible for balance?", options: ["Cochlea", "Eardrum", "Semicircular Canals", "Pinna"], answer: "Semicircular Canals" },
  { question: "What is the derivative of x^2?", options: ["x", "2x", "x^3", "2"], answer: "2x" },
  { question: "Which element has the chemical symbol 'K'?", options: ["Krypton", "Potassium", "Keratin", "Copper"], answer: "Potassium" },
  { question: "What is 30% of 90?", options: ["21", "24", "27", "30"], answer: "27" },
  { question: "Which ray has the highest frequency in the electromagnetic spectrum?", options: ["X-Rays", "Gamma Rays", "Ultraviolet", "Radio Waves"], answer: "Gamma Rays" },
  { question: "How many teeth does a healthy adult human typically have?", options: ["28", "30", "32", "34"], answer: "32" },
  { question: "What is the speed of sound in air approximately?", options: ["343 m/s", "150 m/s", "500 m/s", "1000 m/s"], answer: "343 m/s" },
  { question: "Which hormone is known as the fight-or-flight hormone?", options: ["Insulin", "Adrenaline", "Thyroxine", "Melatonin"], answer: "Adrenaline" },
  { question: "What is the value of 2^10?", options: ["512", "1024", "2048", "4096"], answer: "1024" }
];

export default function ChallengePage() {
  const [name, setName] = useState("");
  const [started, setStarted] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [finished, setFinished] = useState(false);

  const canvasRef = useRef(null);

  const getRandomQuestions = (count = 5) => {
    const shuffled = [...QUESTION_BANK].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  };

  const handleStart = () => {
    if (!name.trim()) return;
    setQuestions(getRandomQuestions(5));
    setStarted(true);
    setCurrentIndex(0);
    setScore(0);
    setTimeLeft(30);
    setFinished(false);
  };

  const handleNextQuestion = useCallback(
    (isCorrect) => {
      if (isCorrect) {
        setScore((prev) => prev + 1);
      }

      if (currentIndex + 1 < questions.length) {
        setCurrentIndex((prev) => prev + 1);
        setTimeLeft(30);
      } else {
        setFinished(true);
      }
    },
    [currentIndex, questions.length]
  );

  useEffect(() => {
    if (!started || finished) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          handleNextQuestion(false);
          return 30;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [started, finished, currentIndex, handleNextQuestion]);

  const handleAnswer = (option) => {
    const isCorrect = option === questions[currentIndex].answer;
    handleNextQuestion(isCorrect);
  };

  // High-Quality E-Certificate Generator using Canvas
  const generateCertificate = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    // HD Resolution Setup
    canvas.width = 1600;
    canvas.height = 1130;

    // Background Gradient
    const bgGradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    bgGradient.addColorStop(0, "#ffffff");
    bgGradient.addColorStop(1, "#fff7ed"); // Warm light orange tint
    ctx.fillStyle = bgGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Decorative Orange & Charcoal Black Borders
    ctx.strokeStyle = "#f97316"; // Brand Orange Outer Border
    ctx.lineWidth = 16;
    ctx.strokeRect(30, 30, canvas.width - 60, canvas.height - 60);

    ctx.strokeStyle = "#0f172a"; // Charcoal Black Inner Border
    ctx.lineWidth = 4;
    ctx.strokeRect(48, 48, canvas.width - 96, canvas.height - 96);

    // Top Header / Subtitle
    ctx.textAlign = "center";
    ctx.fillStyle = "#ea580c"; // Dark Orange Accent
    ctx.font = "bold 26px Inter, sans-serif";
    ctx.fillText("AGNI EDUCATIONAL PLATFORM", canvas.width / 2, 160);

    ctx.fillStyle = "#0f172a"; // Black Title
    ctx.font = "bold 64px Inter, sans-serif";
    ctx.fillText("CERTIFICATE OF ACHIEVEMENT", canvas.width / 2, 240);

    ctx.fillStyle = "#64748b";
    ctx.font = "500 28px Inter, sans-serif";
    ctx.fillText("PROUDLY PRESENTED TO", canvas.width / 2, 320);

    // Student Name (Max 15 Characters & Force Uppercase)
    const formattedName = name.trim().slice(0, 15).toUpperCase();
    ctx.fillStyle = "#0f172a";
    ctx.font = "bold 68px Inter, sans-serif";
    ctx.fillText(formattedName, canvas.width / 2, 420);

    // Dynamic Orange Underline Accent
    ctx.strokeStyle = "#f97316";
    ctx.lineWidth = 5;
    ctx.beginPath();
    ctx.moveTo(canvas.width / 2 - 250, 450);
    ctx.lineTo(canvas.width / 2 + 250, 450);
    ctx.stroke();

    // Achievement Description
    const percent = Math.round((score / questions.length) * 100);
    ctx.fillStyle = "#334155";
    ctx.font = "400 30px Inter, sans-serif";
    ctx.fillText(
      `For successfully completing the AGNI Brain Challenge with a score of ${score} / ${questions.length} (${percent}%).`,
      canvas.width / 2,
      530
    );

    // Draw Logo & Add AGNI TUTOR Name Below
    const logo = new Image();
    logo.src = "./logo.png";
    
    const drawBrandSection = () => {
      // Draw Text Below Logo
      ctx.fillStyle = "#0f172a";
      ctx.font = "bold 28px Inter, sans-serif";
      ctx.fillText("AGNI TUTOR", canvas.width / 2, 730);
      
      completeRendering();
    };

    logo.onload = () => {
      ctx.drawImage(logo, canvas.width / 2 - 50, 590, 100, 100);
      drawBrandSection();
    };
    
    logo.onerror = () => {
      // Fallback Icon Seal if logo.png is missing
      ctx.fillStyle = "#ffedd5";
      ctx.beginPath();
      ctx.arc(canvas.width / 2, 630, 45, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = "#f97316";
      ctx.font = "bold 28px Inter, sans-serif";
      ctx.fillText("🔥", canvas.width / 2, 640);
      drawBrandSection();
    };

    const completeRendering = () => {
      // Date and Verification Signature Info
      const dateStr = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      ctx.fillStyle = "#64748b";
      ctx.font = "500 24px Inter, sans-serif";
      ctx.textAlign = "left";
      ctx.fillText(`Date: ${dateStr}`, 140, 960);

      ctx.textAlign = "right";
      ctx.fillText("AGNI Evaluation Board", canvas.width - 140, 960);

      ctx.strokeStyle = "#0f172a";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(canvas.width - 380, 925);
      ctx.lineTo(canvas.width - 120, 925);
      ctx.stroke();

      // Trigger File Download
      const imageURI = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.download = `${formattedName}_AGNI_Certificate.png`;
      link.href = imageURI;
      link.click();
    };
  };

  if (!started) {
    return (
      <div className="challenge-container">
        <div className="challenge-card">
          <h1>🧠 Test Your Brain</h1>
          <p className="subtitle">Answer 5 random questions (30 seconds each)!</p>
          <input
            type="text"
            className="modern-input"
            placeholder="Enter Your Name (Max 15 Chars)"
            maxLength={15}
            value={name}
            onChange={(e) => setName(e.target.value.toUpperCase())}
          />
          <button className="btn btn-primary" onClick={handleStart}>
            Start Challenge
          </button>
        </div>
      </div>
    );
  }

  if (finished) {
    const passed = score >= 3;
    const percentage = Math.round((score / questions.length) * 100);

    return (
      <div className="challenge-container">
        {/* Hidden Canvas used for e-certificate generation */}
        <canvas ref={canvasRef} style={{ display: "none" }} />

        <div className="challenge-card">
          <h1>{passed ? "🏆 Excellent!" : "🎯 Good Attempt!"}</h1>
          <h2 className="user-name">{name}</h2>

          <div className="score-badge">
            Score: <span>{score}</span> / {questions.length}
          </div>

          <div className="progress-bar-wrapper">
            <div
              className="progress-bar-fill score-progress"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>

          <p className="status-text">
            {passed
              ? "You passed the AGNI Brain Challenge!"
              : "Keep practicing to improve your score!"}
          </p>

          <div className="action-buttons">
            <button className="btn btn-primary" onClick={generateCertificate}>
              🎓 Download Certificate
            </button>

            <button className="btn btn-secondary" onClick={handleStart}>
              Try Another 5 Questions
            </button>
          </div>

          <div className="divider" />

          <h3>🤖 Want More Practice?</h3>
          <a href="/" className="launch-link">
            <button className="btn btn-accent">Launch AGNI TUTOR</button>
          </a>
        </div>
      </div>
    );
  }

  const currentQ = questions[currentIndex];
  const questionProgress = ((currentIndex + 1) / questions.length) * 100;
  const timerProgress = (timeLeft / 30) * 100;

  return (
    <div className="challenge-container">
      <div className="challenge-card">
        {/* Overall Quiz Progress Bar */}
        <div className="quiz-progress-container">
          <div className="progress-info">
            <span>Question {currentIndex + 1} of {questions.length}</span>
            <span className="timer-badge">⏰ {timeLeft}s</span>
          </div>
          <div className="progress-bar-wrapper">
            <div
              className="progress-bar-fill"
              style={{ width: `${questionProgress}%` }}
            ></div>
          </div>
        </div>

        {/* Per-Question Timer Bar (Green above 50%, Red at or below 50%) */}
        <div className="timer-bar-wrapper">
          <div
            className={`timer-bar-fill ${timerProgress <= 50 ? "warning" : ""}`}
            style={{ width: `${timerProgress}%` }}
          ></div>
        </div>

        <h2 className="question-text">{currentQ?.question}</h2>

        <div className="options">
          {currentQ?.options.map((option) => (
            <button
              key={option}
              className="btn btn-option"
              onClick={() => handleAnswer(option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}